import adminAppData from './appData';
import { adminSetupReducer } from './setup';
import adminAwardingRule from './awardingRule';
import globalSetupAppData from './globalSetup';

export default {
    adminAppData,
    adminSetup: adminSetupReducer,
    adminAwardingRule,
    globalSetupAppData,
};
